import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const StatsSetSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"StatsSet Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[

                            {
                                label: "Type",
                                key: "type",
                            },
                            {
                                label: "Status",
                                key: "status",
                                format: "titleCase",
                            },
                            {
                                label: "User",
                                key: "owner",
                                format: "ModelLink"
                            },
                            {
                                label: "Group",
                                key: "group",
                                format: "ModelLink"
                            },

                        ]}
                        columnB={[
                            {
                                label: "League",
                                key: "league",
                                format: "ModelLink"
                            },
                            {
                                label: "Season",
                                key: "season",
                                format: "ModelLink"
                            },
                            {
                                label: "Team",
                                key: "team",
                                format: "ModelLink"
                            },
                            {
                                label: "Player",
                                key: "player",
                                format: "ModelLink"
                            },
                        ]}
                        columnC={[
                            {
                                label: "Created On",
                                key: "created",
                                format: "onAndBy",
                            }
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default StatsSetSingleView;
